import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

export interface KpiCardProps {
  label: ReactNode;
  value: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function KpiCard({ label, value, footer, className }: KpiCardProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-1 rounded-md border border-border bg-surface p-3 shadow-sm',
        className,
      )}
    >
      <div className="text-xs font-medium uppercase tracking-wide text-fg-muted">{label}</div>
      <div className="text-xl font-semibold tracking-tight text-fg">{value}</div>
      {footer ? <div className="text-xs text-fg-muted">{footer}</div> : null}
    </div>
  );
}
